import type { ReactNode } from "react";

import { translate } from "app/filters/i18nFilter";
import { numberFilter } from "app/filters/numberFilter";
import { createPluralHelperForI18nKey } from "app/pages/sales-intelligence/utils/strings";
import { StyledLink } from "pro-features/styled components/StyledLink/src/StyledLink";

import type { BaseRow, CellProps } from "../../../types/table";

import { StyledText, StyledTitle, StyledTitleWrapper, StyleIconCell } from "./styles";

type Row = BaseRow & {
    accountCount: number;
};

type Props<R> = CellProps<R> & {
    tag?: ReactNode;
    className?: string;
};

const ResultAssetCell = <R extends Row>({ tag, className, onClick, ...cellProps }: Props<R>) => {
    const key = createPluralHelperForI18nKey("si.pages.home.table-columns.accounts.company.count")(
        cellProps.row.accountCount,
    );
    const text: string = translate(key, {
        value: numberFilter()(cellProps.row.accountCount),
    });

    const titleText = <StyledTitle data-automation-title={cellProps.value}>{cellProps.value}</StyledTitle>;

    const title = tag ? (
        <StyledTitleWrapper>
            {titleText}
            {tag}
        </StyledTitleWrapper>
    ) : (
        titleText
    );

    return (
        <StyleIconCell
            className={className}
            {...cellProps}
            iconName={cellProps.row.iconName}
        >
            <StyledLink
                data-automation="asset-link"
                onClick={onClick}
            >
                {title}
                <StyledText data-automation-text={text}>{text}</StyledText>
            </StyledLink>
        </StyleIconCell>
    );
};

export default ResultAssetCell;
